import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';
import { Flex, Toast, Tabs, ListView, Button, TextareaItem } from 'antd-mobile';
import { Carousel } from 'antd-mobile';
import NavBar from 'widget/NavBar';
import cx from 'classnames';
import './AIImageTextLess.less';
import EmptyTips from 'pubBiz/EmptyTips';
import Util from 'utils';
import AIImageTextMod from './AIImageTextMod';
import CommonBtn from 'pubBiz/CommonBtn/CommonBtnView';
import copy from 'copy-to-clipboard';
import { throttleAction } from 'utils/throttledJump';
import { divide, isEmpty, multiply } from 'lodash';

@observer
export default class AIImageTextView extends Component {
  constructor(props) {
    super(props);
    this.store = new AIImageTextMod();
    this.state = {
      current: '',
      showImgModal: false,
      posterList: []
    };
  }

  async componentDidMount() {
    const { id } = Util.decodeQuery(this.props.location.search);
    await this.store.getWordImageDetail(id); // '1401541787128067153'
    this.generateAILogo();
  }

  changeUrl = (url) => {
    console.log('urlurlsssss', url);

    const returnUrl = url
      .replace('yofoto-test.obs.cn-east-2.myhuaweicloud.com', 'image-test.yofoto.cn')
      .replace('bucket-prod.obs.cn-east-2.myhuaweicloud.com', 'image.yofogo.com')
      .replace('bucket-uat.obs.cn-east-2.myhuaweicloud.com', 'image-uat.yofoto.cn');

    return returnUrl;
  };

  async generateAILogo() {
    let { imageList } = this.store;
    const { posterList } = this.state;
    imageList = toJS(imageList);
    console.log(posterList.length, 'imageListss22', imageList);
    let posterUrl = imageList[posterList.length];
    const oCanvas = document.createElement('canvas');
    const context = oCanvas.getContext('2d');
    const posterSrc = this.changeUrl(posterUrl);
    const posterImg = new Image();
    posterImg.setAttribute('crossOrigin', 'Anonymous');
    posterImg.src = posterSrc;
    posterImg.onload = () => {
      const posterW = 750; // 海报原尺寸宽度
      const posterH = (posterW / posterImg.width) * posterImg.height; // multiply(posterImg.height, divide(posterW, posterImg.width)); // multiply() //(posterW / posterImg.width) * posterImg.height; // 海报原尺寸宽度
      oCanvas.width = posterW;
      oCanvas.height = posterH;
      context.drawImage(posterImg, 0, 0, posterW, posterH);
      // const aiLogoImg = new Image();
      // aiLogoImg.setAttribute('crossOrigin', 'Anonymous');
      // //  aiLogoImg.src = 'https://picsum.photos/200';
      // aiLogoImg.src = 'https://image.yofogo.com/assets/aiLogo_h.png';
      // aiLogoImg.onload = () => {
      //   context.drawImage(aiLogoImg, 32, 32, 82, 28);
      if (posterList.length < imageList.length) {
        posterList[posterList.length] = oCanvas.toDataURL();
        this.setState(
          {
            posterList
          },
          () => {
            if (posterList.length < imageList.length) {
              this.generateAILogo(imageList);
            }
          }
        );
      }
      // };
      // aiLogoImg.onerror = (error) => {
      //   console.log('logo加载失败', error);
      // };
    };
    posterImg.onerror = (error) => {
      console.log('主图加载失败', error);
    };
  }

  /**
   * 下载按钮
   */
  renderDownload() {
    const isWeChat = Util.isWeiXin();
    const returnValue = Util.getVersion();

    return (
      <CommonBtn
        className="save_button"
        title={
          isWeChat ? '长按图片保存/转发' : returnValue === 'google' ? '保存图片' : '长按图片保存'
        }
        onClick={(e) => !isWeChat && this.downloadImg(e)}
      />
    );
  }

  copyInfo = (content) => {
    const s = Util.copyText(content);
    if (s) {
      Toast.info('复制成功', 1);
    } else {
      Toast.info('复制失败', 1);
    }
  };

  downloadImg = throttleAction((e) => {
    e.stopPropagation();
    const { current } = this.state;
    // const { imageList } = this.store;
    // const img = new Image();
    // img.crossOrigin = 'anonymous';
    // img.src = toJS(imageList)[current];
    // img.onload = () => {
    //   const canvas = document.createElement('canvas');
    //   const ctx = canvas.getContext('2d');
    //   canvas.width = img.width;
    //   canvas.height = img.height;
    //   ctx.drawImage(img, 0, 0);
    //   const dataURL = canvas.toDataURL('image/jpeg');
    //   const a = document.createElement('a');
    //   a.href = dataURL;
    //   a.download = `AI图文.png`;
    //   a.click();
    //   Toast.info('图片已保存成功', 1);
    // };
    const { posterList } = this.state;
    const dataURL = posterList[current];
    const a = document.createElement('a');
    a.href = dataURL;
    a.download = `AI图文.png`;
    a.click();
    Toast.info('图片已保存成功', 1);
  });

  render() {
    const { imageList, detailData, shareImgSrc } = this.store;
    const shareImgs = toJS(shareImgSrc);
    const { showImgModal, current, posterList } = this.state;
    return (
      <div className="ai_image_text_container">
        <NavBar
          hasLeft={true}
          title={'AI图文'}
          shadowStyle={false}
          onLeftClick={() => {
            window.app.routerRedirect('/');
          }}
        />
        <div className="image_text_content">
          <div className="image_text_info" style={{ height: `calc(100vh - 90px - 120px)` }}>
            <div className="name_group">
              <div className="name_title">图文名称</div>
              <div className="name_product">{detailData.wordTitle}</div>
            </div>
            <div className="share_group">
              <div className="name_title">分享图文</div>
              <div className="share_content">
                <div id="contentDiv" className="share_intro">
                  {detailData.wordContent}
                </div>
                <div className="share_images">
                  {imageList.map((val, index) => (
                    <div className="share_images_group">
                      <img
                        onClick={() => {
                          // if (imageList.length === posterList.length) {
                          this.setState({
                            showImgModal: true,
                            current: index
                          });
                          // } else {
                          //   Toast.info('图片生成中，请稍后');
                          // }
                        }}
                        className="image_item"
                        key={index}
                        src={val}></img>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="copy_content">
            <div
              className="copy_botton"
              onClick={() => {
                this.copyInfo(detailData.wordContent);
              }}>
              一键复制文案
            </div>
          </div>
        </div>

        <div
          id="aiImgModal"
          style={{
            top: showImgModal ? '0' : '-9999px'
          }}
          onClick={(e) => {
            e.stopPropagation();
            this.setState({
              showImgModal: false
            });
          }}>
          <div className="swiperDots">
            <span>{`${current + 1} / ${posterList.length}`}</span>
          </div>

          <Carousel
            className="prevSwiper"
            infinite
            dots={false}
            afterChange={(index) => {
              this.setState({ current: index });
            }}
            selectedIndex={current}>
            {(posterList || []).map((item, i) => {
              return (
                <div id={`ai_img_${i}`} className="carousel_item">
                  <img
                    className="swiper_img"
                    key={i}
                    //   src={Util.getImgUrl(item, 750)}
                    src={item}
                    // src={shareImgs[i]}
                    //   onLoad={() => {
                    //     // 用于更改img的高度;
                    //     window.dispatchEvent(new Event('resize'));
                    //   }}
                  />
                </div>
              );
            })}
          </Carousel>
          {this.renderDownload()}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/AICreation/AIImageText/AIImageTextView.js